// extracted by mini-css-extract-plugin
export var mainImage = "wheelsPage-module--mainImage--8jNV6";